const threadRegex = /^thread:([A-Za-z0-9-]*)$/;

/*
    Helper functions to hackily parse thread "fake" channel slugs
*/
export const MBChannelTypeUtil = {
  isThread(channelSlug: string): boolean {
    const match = channelSlug.match(threadRegex);
    return !!match;
  },

  parseThreadIdFromChannelSlug(channelSlug: string): string | undefined {
    // [fullMatch: string, threadId: string]
    const match = channelSlug.match(threadRegex);
    if (!match) {
      return undefined;
    }
    return match[1];
  },
};
